import { cn } from "../../../lib/utils.js";

/** Timestamp/status chip for media-as-bubble layouts. */
export function MediaTimestampOverlay({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn(
        "pointer-events-none absolute bottom-1.5 end-1.5 z-[2] flex max-w-[calc(100%-0.75rem)] items-center gap-1",
        "rounded-full bg-ink/60 px-2 py-0.5 text-surface-elevated shadow-sm backdrop-blur-[3px]",
        className,
      )}
    >
      {children}
    </div>
  );
}
